import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FeUtil, API } from '../../../hezky-routes';

@Injectable({ providedIn: 'root' })
export class DeviceService {
    constructor(private readonly feUtil: FeUtil) { }

    public getDeviceCertificate(payload: any): Observable<any> {
        return this.feUtil.httpSvc.post(API.DEVICE.STORAGE.GET_DEVICE_CERTIFICATE, payload);
    }

    // * TRANSPORT
    public getDevices(payload: any): Observable<any> {
        return this.feUtil.httpSvc.get(API.DEVICE.STORAGE.DEVICES, payload);
    }

    // * TRANSPORT APIS
    public fetchAllTransportSensors(params?: any): Observable<any> {
        return this.feUtil.httpSvc.get(API.DEVICE.TRANSPORT.GET_DEVICES, params);
    }
    public updateTrSensor(id: string, payload: any): Observable<any> {
        return this.feUtil.httpSvc.patch(API.DEVICE.TRANSPORT.UPDATE_STATUS(id), payload);
    }

    // * AQI APIS
    public getAqiData(params: any): Observable<any> {
        return this.feUtil.httpSvc.post(API.DEVICE.AQI.GET_AQI_DATA, params);
    }



    // getAllAvailableDevices(data: any): Observable<any[]> {
    //     return this.feUtil.httpSvc.post<any[]>(environment.apiBaseUrl + API_ENDPOINTS.ADMIN.DEVICE_MANAGEMENT.AVAILABLE_DEVICES, data)
    // }
    // GATEWAY APIS
    // public getAllGateway(gateway: any): Observable<any> {
    //     return this.feUtil.httpSvc.post<any[]>(environment.apiBaseUrl + API_ENDPOINTS.ADMIN.DEVICE_MANAGEMENT.GATEWAY.LIST, gateway)
    // }
    // public getGatewayById(sensor_id: any): Observable<any[]> {
    //     return this.feUtil.httpSvc.post<any[]>(environment.apiBaseUrl + API_ENDPOINTS.ADMIN.DEVICE_MANAGEMENT.GATEWAY.DATA_BY_ID, sensor_id)
    // }
    // public addGateway(data: any): Observable<any> {
    //     return this.feUtil.httpSvc.post(environment.apiBaseUrl + API_ENDPOINTS.ADMIN.DEVICE_MANAGEMENT.GATEWAY.CREATE, data)
    // }
    // public updateGateway(data: any): Observable<any> {
    //     return this.feUtil.httpSvc.post(environment.apiBaseUrl + API_ENDPOINTS.ADMIN.DEVICE_MANAGEMENT.GATEWAY.UPDATE, data)
    // }
    // public deleteGateway(data: any): Observable<any> {
    //     return this.feUtil.httpSvc.post(environment.apiBaseUrl + API_ENDPOINTS.ADMIN.DEVICE_MANAGEMENT.GATEWAY.DELETE, data)
    // }
    // public getGatewayLogs(data: any): Observable<any> {
    //     return this.feUtil.httpSvc.post<any[]>(environment.baseUrl + API_ENDPOINTS.ADMIN.DEVICE_MANAGEMENT.GATEWAY.LOGS, data)
    // }

    // SENSOR APIS
    // public getAllSensors(user_id: any): Observable<any[]> {
    //     return this.feUtil.httpSvc.post<any[]>(environment.apiBaseUrl + API_ENDPOINTS.ADMIN.DEVICE_MANAGEMENT.SENSOR.LIST, user_id)
    // }
    // public getSensorById(sensor_id: any): Observable<any[]> {
    //     return this.feUtil.httpSvc.post<any[]>(environment.apiBaseUrl + API_ENDPOINTS.ADMIN.DEVICE_MANAGEMENT.SENSOR.DATA_BY_ID, sensor_id)
    // }
    // public addSensor(data: any): Observable<any> {
    //     return this.feUtil.httpSvc.post(environment.apiBaseUrl + API_ENDPOINTS.ADMIN.DEVICE_MANAGEMENT.SENSOR.CREATE, data)
    // }
    // public updateSensor(data: any): Observable<any> {
    //     return this.feUtil.httpSvc.post(environment.apiBaseUrl + API_ENDPOINTS.ADMIN.DEVICE_MANAGEMENT.SENSOR.UPDATE, data)
    // }
    // public deleteSensor(data: any): Observable<any> {
    //     return this.feUtil.httpSvc.post(environment.apiBaseUrl + API_ENDPOINTS.ADMIN.DEVICE_MANAGEMENT.SENSOR.DELETE, data)
    // }
    // public getSensorLogs(data: any): Observable<any> {
    //     return this.feUtil.httpSvc.post<any[]>(environment.baseUrl + API_ENDPOINTS.ADMIN.DEVICE_MANAGEMENT.GATEWAY.LOGS, data)
    // }



    // HOOTER APIS
    // public getAllHooters(user_id: any): Observable<any[]> {
    //     return this.feUtil.httpSvc.post<any[]>(environment.apiBaseUrl + API_ENDPOINTS.ADMIN.DEVICE_MANAGEMENT.HOOTER.LIST, user_id)
    // }
    // public getHooterById(sensor_id: any): Observable<any[]> {
    //     return this.feUtil.httpSvc.post<any[]>(environment.apiBaseUrl + API_ENDPOINTS.ADMIN.DEVICE_MANAGEMENT.HOOTER.DATA_BY_ID, sensor_id)
    // }
    // public addHooter(data: any): Observable<any> {
    //     return this.feUtil.httpSvc.post(environment.apiBaseUrl + API_ENDPOINTS.ADMIN.DEVICE_MANAGEMENT.HOOTER.CREATE, data)
    // }
    // public updateHooter(data: any): Observable<any> {
    //     return this.feUtil.httpSvc.put(environment.apiBaseUrl + API_ENDPOINTS.ADMIN.DEVICE_MANAGEMENT.HOOTER.UPDATE, data)
    // }
    // public deleteHooter(data: any): Observable<any> {
    //     return this.feUtil.httpSvc.post(environment.apiBaseUrl + API_ENDPOINTS.ADMIN.DEVICE_MANAGEMENT.HOOTER.DELETE, data)
    // }
}